/** Managed dashboards (lane D1). Widget ids only, never widget data. Mirrors ManagedDashboardDtos. */

export type ManagedSource = 'PERSON' | 'DEPARTMENT' | 'COMPANY' | 'PRESET';

export interface ManagedBoard {
    userId: string;
    boardKey: string;
    widgetIds: string[];
    lockedWidgetIds: string[];
    source: ManagedSource | string;
    sourceDepartmentId: string | null;
    sourceRoleId: string | null;
    personalised: boolean;
    setByKind: string | null;
    setBy: string | null;
}

export interface BoardRequest {
    widgetIds: string[];
    lockedWidgetIds: string[];
}

export interface DashboardDefault {
    id: string;
    roleId: string;
    departmentId: string | null;
    boardKey: string;
    widgetIds: string[];
    lockedWidgetIds: string[];
    priority: number;
}

export interface DefaultRequest {
    roleId: string;
    departmentId?: string | null;
    boardKey: string;
    widgetIds: string[];
    lockedWidgetIds: string[];
    priority?: number | null;
}

export interface ManagedPerson {
    userId: string;
    username: string;
    name: string | null;
    /** Active role names in this institution. */
    roles?: string[];
}

export interface BoardAuditRow {
    id: string;
    actorId: string;
    actorKind: string;
    action: string;
    boardKey: string;
    before: string[];
    after: string[];
    at: string;
}

export interface DefaultAuditRow extends BoardAuditRow {
    roleId: string | null;
    departmentId: string | null;
}

export interface TargetRole { id: string; name: string }
export interface TargetDepartment { id: string; name: string; parentId: string | null }
/** What the caller may pick when setting a default (GET .../targets). */
export interface DefaultTargets { roles: TargetRole[]; departments: TargetDepartment[] }

/** Board keys a layout can be stored under; the first five are the home pages. */
export const MANAGED_BOARD_KEYS: { key: string; label: string }[] = [
    { key: 'home', label: 'Home board (admin / manager / finance)' },
    { key: 'store', label: 'Store home page' },
    { key: 'commercial', label: 'Commercial home page' },
    { key: 'sales-home', label: 'Sales home page' },
    { key: 'sales', label: 'Sales deep page' },
    { key: 'personal', label: 'Employee home page' },
    { key: 'attendance', label: 'Attendance deep page' },
    { key: 'leave', label: 'Leave deep page' },
    { key: 'people', label: 'People deep page' },
    { key: 'accounting', label: 'Accounting deep page' },
    { key: 'inventory', label: 'Inventory deep page' },
    { key: 'payroll', label: 'Payroll deep page' },
    { key: 'expense', label: 'Expense deep page' },
    { key: 'home-thread', label: 'Home board, Thread style (admin / manager / finance)' },
];

/** Priority floor the backend enforces for a MANAGE_TEAM caller (only MANAGE_ALL may go lower). */
export const TEAM_PRIORITY_FLOOR = 100;
/** Highest priority the backend accepts. */
export const MAX_PRIORITY = 10000;
